module.exports = __webpack_public_path__ + "img/4-shaman-helper_v8e.f39b4538.png";